import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=00266744&scoped=true"
import script from "./orderInfo.vue?vue&type=script&lang=js"
export * from "./orderInfo.vue?vue&type=script&lang=js"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=00266744&prod&scoped=true&lang=css"
import style1 from "./orderInfo.vue?vue&type=style&index=1&id=00266744&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00266744",
  null
  
)

export default component.exports